import { call, take, fork } from "redux-saga/effects";
import { eventChannel, buffers } from "redux-saga";

/*
USE: Allows return values from saga fork()

         const asyncsaga = new AsyncSaga();

         yield asyncsaga.fork("Id1", ruleservice.GetDataForRuleInsts, arg1, arg2);
         yield asyncsaga.fork("Id2", ruleservice.GetRuleCategories, arg);
         yield asyncsaga.fork("Id3", ruleservice.GetDataForRulesForCategory);

         for (
            let forkResult = yield call(asyncsaga.ReadResult);
            forkResult;
            forkResult = yield call(asyncsaga.ReadResult)
         ) {
            console.log(forkResult);
         }

         asyncsaga.End();

*/
export default class AsyncSaga {
   /**
    * Flag end of aggregated arguments to be sent to the called function, specified in `fork()`.
    * Use this seperate call arguments from fork consumer arguments that may be accessed in `result.args`
    */
   static END_OF_ARGS = "END_OF_ARGS";

   constructor(buffer = 20) {
      this.buffer = buffer;
      this._socketChannel = this._readSocket();
      this.pendings = [];
      this.ReadResult = this.ReadResult.bind(this);
      this.fork = this.fork.bind(this);
      this.End = this.End.bind(this);
      this.isInit = true;
   }

   End() {
      this._socketChannel.close();
   }

   dispatcher = null;

   /**
    * Get next result in queue. return null if all calls have completed.
    */
   *ReadResult() {
      if (this.pendings.length > 0) {
         const result = yield take(this._socketChannel);
         this.pendings.splice(0, 1);
         return result;
      } else {
         return null;
      }
   }

   _readSocket() {
      return eventChannel(emitter => {
         this.dispatcher = value => {
            emitter(value);
         };

         // The subscriber must return an unsubscribe function
         return () => {
            this.dispatcher = null;
         };
      }, buffers.expanding(this.buffer));
   }

   /**
    * Call task and return the result via this.socketChannel.
    * Only args before `AsyncSaga.END_OF_ARGS` will be sent to the func
    * @param {string} id Identifier for this task
    * @param {function} func Function to call
    * @param {*} args
    */
   fork(id, func, ...args) {
      return fork(
         function*() {
            if (!this.isInit) {
               throw new Error("AsyncSaga not inited");
            }
            this.pendings.push(id);
            const eoa = args.indexOf(AsyncSaga.END_OF_ARGS);
            const data = yield call(func, ...(eoa > 0 ? args.slice(0, eoa) : args));
            this.dispatcher({ id, data: data, args });
         }.bind(this)
      );
   }
}



// WEBPACK FOOTER //
// ./src/utils/asyncSaga.js